import styled from 'styled-components'

interface IRadioStyledProps {
  isDisabled: boolean
}

export const RadioStyled = styled.label<IRadioStyledProps>`
  display: block;

  font-size: ${(props) => props.theme.typography.body2.fontSize};

  cursor: pointer;

  input {
    margin: 0 0 0 0;
    accent-color: ${(props) => props.theme.colors.primary};
  }

  ${(props) =>
    props.isDisabled &&
    `
    cursor: not-allowed;

    > * {
      opacity: 0.35;
    }
  `}
`
